// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Location\ApiLocation.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { GeoActivity, GeoActivityData, GeoActivityOptions } from 'data/models/GeoActivity';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { Location as _Location, LocationData as _LocationData, LocationOptions as _LocationOptions } from 'data/models/Location';
import { Port, PortData, PortOptions } from 'data/models/Port';

// LocationData is the class that Location serializes to/from
export interface LocationData {
    Id : number;
    Url : string | null;
	
    Berth : BerthData | null;
    ContainingLocation : _LocationData | null;
    ContainingLocationId : number | null;
    GeoActivities : GeoActivityData[] | null;
    Itinerary : ItineraryPointData[] | null;
    Port : PortData | null;
    PortId : number;
	
    DefaultPortEntry : boolean;
    Guid : /* GUID */ string;
    IsPortExternal : boolean;
    Name : string;
    PortCDMName : string | null;
    PortEntry : boolean;
    ZoneCoordinates : string | null;
    ZoneType : string | null;
}

// LocationOptions is the class which may be passed to the Location constructor to define optional initial data values
export interface LocationOptions {
    Id : number;
    Url? : string | null;
	
    Berth? : BerthOptions | null;
    ContainingLocation? : _LocationOptions | null;
    ContainingLocationId? : number | null;
    GeoActivities? : GeoActivityOptions[] | null;
    Itinerary? : ItineraryPointOptions[] | null;
    Port? : PortOptions | null;
    PortId? : number;
	
    DefaultPortEntry? : boolean;
    Guid? : /* GUID */ string;
    IsPortExternal? : boolean;
    Name? : string;
    PortCDMName? : string | null;
    PortEntry? : boolean;
    ZoneCoordinates? : string | null;
    ZoneType? : string | null;
}

export class Location {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berth : DataSignal<Berth | null>;
    public ContainingLocation : DataSignal<_Location | null>;
    public ContainingLocationId : DataSignal<number | null>;
    public GeoActivities : SDataArray<GeoActivity>;
    public Itinerary : SDataArray<ItineraryPoint>;
    public Port : DataSignal<Port | null>;
    public PortId : DataSignal<number>;
	
    public DefaultPortEntry : DataSignal<boolean>;
    public Guid : DataSignal<string>;
    public IsPortExternal : DataSignal<boolean>;
    public Name : DataSignal<string>;
    public PortCDMName : DataSignal<string | null>;
    public PortEntry : DataSignal<boolean>;
    public ZoneCoordinates : DataSignal<string | null>;
    public ZoneType : DataSignal<string | null>;

    constructor();
    constructor(data : LocationOptions);
    constructor(data: LocationOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berth = S.value<Berth | null>(null);
        this.ContainingLocation = S.value<_Location | null>(null);
        this.ContainingLocationId = jsonableObservable(S.value<number | null>(data && data.ContainingLocationId !== undefined ? data.ContainingLocationId : null));
        this.GeoActivities = SArray<GeoActivity>([]);
        this.Itinerary = SArray<ItineraryPoint>([]);
        this.Port = S.value<Port | null>(null);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
        this.DefaultPortEntry = jsonableObservable(S.value<boolean>(data && data.DefaultPortEntry !== undefined ? data.DefaultPortEntry : false));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsPortExternal = jsonableObservable(S.value<boolean>(data && data.IsPortExternal !== undefined ? data.IsPortExternal : false));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.PortCDMName = jsonableObservable(S.value<string | null>(data && data.PortCDMName !== undefined ? data.PortCDMName : null));
        this.PortEntry = jsonableObservable(S.value<boolean>(data && data.PortEntry !== undefined ? data.PortEntry : false));
        this.ZoneCoordinates = jsonableObservable(S.value<string | null>(data && data.ZoneCoordinates !== undefined ? data.ZoneCoordinates : null));
        this.ZoneType = jsonableObservable(S.value<string | null>(data && data.ZoneType !== undefined ? data.ZoneType : null));
    }

    static key(obj : Location) {
        return obj.Id();
    }
    
    static dataKey(obj : LocationOptions) {
        return obj.Id;
    }

    static update(obj : Location, data : LocationOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.ContainingLocationId !== undefined) obj.ContainingLocationId(data.ContainingLocationId);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
            if (data.DefaultPortEntry !== undefined) obj.DefaultPortEntry(data.DefaultPortEntry);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IsPortExternal !== undefined) obj.IsPortExternal(data.IsPortExternal);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.PortCDMName !== undefined) obj.PortCDMName(data.PortCDMName);
            if (data.PortEntry !== undefined) obj.PortEntry(data.PortEntry);
            if (data.ZoneCoordinates !== undefined) obj.ZoneCoordinates(data.ZoneCoordinates);
            if (data.ZoneType !== undefined) obj.ZoneType(data.ZoneType);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Location.ts